
<nz-layout>
  <nz-content class="centered">
    <div class="centered-box-vertical">
      <img class="logo" src="assets/img/teamsystem.png" />
      <h1 i18n="Auth.UsernameLost.Title|title for lost username page@@Auth.UsernameLost.Title">
        Recupero Username
      </h1>
      <span i18n="Auth.UsernameLost.Subtitle|subtitle for lost username page@@Auth.UsernameLost.Subtitle">
        Dopo l'invio dei dati riceverai una mail con la username.
      </span>
      <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
      nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
        <form nz-form [formGroup]="usernameLostForm" class="custom-form" (ngSubmit)="submitForm()">
          <nz-form-item class="login">
            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-control
                [nzErrorTip]="getValidationErrorMessage(usernameLostForm.controls.email.errors)">
                  <nz-input-group nzPrefixIcon="user" class="login">
                    <input type="email" nz-input formControlName="email" 
                    i18n-placeholder="Auth.Generic.PlaceholderEmail|placeholder for email in form@@Auth.Generic.PlaceholderEmail"
                    placeholder="Email" />
                  </nz-input-group>
                </nz-form-control>
              </div>
            </div>
          </nz-form-item>

          <nz-form-item class="login">
            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-control
                [nzErrorTip]="getValidationErrorMessage(usernameLostForm.controls.user_vat.errors)">
                  <nz-input-group nzPrefixIcon="lock" class="login">
                    <input type="text" nz-input formControlName="user_vat" 
                    i18n-placeholder="Auth.Generic.PlaceholderVATNumber|placeholder for vat number in form@@Auth.Generic.PlaceholderVATNumber"
                    placeholder="Codice Fiscale o Partita IVA" />
                  </nz-input-group>
                </nz-form-control>
              </div>
            </div>
          </nz-form-item>

          <div nz-row nzAlign="middle">
            <div nz-col [nzSpan]="16">
              <a class="custom-form-forgot" [routerLink]="getAuthLink()">
                <i nz-icon nzType="arrow-left" nzTheme="outline" style="margin-right: 0.5rem;"></i>
                <ng-container
              i18n="Auth.Generic.BackToSignInPage|label for go back to sign in page@@Auth.Generic.BackToSignInPage">
              Torna alla pagina di accesso
            </ng-container></a>
            </div>
            <div nz-col [nzSpan]="8">
              <button i18n="Generic.Send|label for send button@@Generic.Send"
              class="submit" nz-button [nzType]="'primary'" [disabled]="!usernameLostForm.valid">INVIA</button>
            </div>
          </div>

        </form>
      </nz-spin>

    </div>
  </nz-content>
</nz-layout>